export default "__VITE_ASSET__CVVhx0Hl__"